import { Button, Form, Input, message } from 'antd'
import SettingsCard from 'egi/app/Settings/components/SettignsCard/SettingsCard'
import React, { useEffect, useState } from 'react'
import { IPartnerDetail, parseJsonWithLine, PartnerUpdateBody } from '../partnerApiCredentials'

interface IProps {
  promoter: IPartnerDetail
  onSave: (body: PartnerUpdateBody) => Promise<void>
}

const formatFields = (callbackFields?: Record<string, unknown>) => callbackFields ? JSON.stringify(callbackFields, null, 2) : ''

export default function CallbackFieldsSection ({ promoter, onSave }: IProps) {
  const [text, setText] = useState(formatFields(promoter.callbackFields))
  const [saving, setSaving] = useState(false)
  const [serverError, setServerError] = useState<string>()
  const { value, error } = parseJsonWithLine(text)

  const callbackFieldsKey = JSON.stringify(promoter.callbackFields)

  useEffect(() => {
    setText(formatFields(callbackFieldsKey ? JSON.parse(callbackFieldsKey) : undefined))
    setServerError(undefined)
  }, [callbackFieldsKey])

  const beautify = () => {
    if (value) setText(JSON.stringify(value, null, 2))
    else if (error) message.error(error)
  }

  const save = async () => {
    setSaving(true)
    setServerError(undefined)
    try {
      await onSave({ callbackFields: value ?? '' })
    } catch (err) {
      setServerError(err.message)
      message.error(err.message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <SettingsCard className="mb-2">
      <SettingsCard.title>Campos do callback</SettingsCard.title>
      <SettingsCard.description>JSON com os campos enviados no postback (callbackFields).</SettingsCard.description>

      <Form layout="vertical" className="mt-3" onFinish={save}>
        <div className="flex flex-justify-between flex-align-center mb-2">
          <label className="font-500" htmlFor="partner-callback-fields">callbackFields (JSON)</label>
          <Button type="ghost" onClick={beautify} disabled={!text.trim()}>Formatar</Button>
        </div>

        <Form.Item
          validateStatus={error || serverError ? 'error' : undefined}
          help={error ?? serverError}
          extra={
            <>
              <p>JSON válido. Esses campos definem o que o parceiro recebe nos callbacks e na listagem de propostas.</p>
              <p className="mt-2">
                Caminhos aceitos: proposal., client., product., partner., fixed.text., calculate., format., forms., department, step. Objetos aninhados são permitidos.
              </p>
            </>
          }
        >
          <Input.TextArea
            id="partner-callback-fields"
            rows={10}
            spellCheck={false}
            style={{ fontFamily: 'monospace', borderRadius: 5 }}
            value={text}
            onChange={(event) => setText(event.target.value)}
          />
        </Form.Item>

        <SettingsCard.ButtonsContainer>
          <SettingsCard.submitButton loading={saving} disabled={Boolean(error)}>Salvar</SettingsCard.submitButton>
        </SettingsCard.ButtonsContainer>
      </Form>
    </SettingsCard>
  )
}
